import React, {useContext} from "react";
import PortalComunicacao from "./PortalComunicacao";
import { Grid } from "@material-ui/core";
import { FormIcon , TutorialIcon , ChatIcon, ForumIcon }  from '../../../assets/images/portal/iconsPortal'
import { ThemeContext } from 'styled-components';


export const ComunicacaoList = () => {

  const theme = useContext(ThemeContext)

  return (
    <Grid container spacing={2} justifyContent="center">
      <PortalComunicacao
        image={<ChatIcon theme={theme.primary}/>}
        title='Chat'
        subTitle="Ferramenta de conversa individual ou coletiva direta com os alunos."
        link=''
      />
      <PortalComunicacao
        image={<ForumIcon theme={theme.primary}/>}
        title='Fórum'
        subTitle="Ferramenta de conversa coletiva direta com os alunos."
        link=''
      />
      <PortalComunicacao
        image={<FormIcon theme={theme.primary}/>}
        title='Enquete'
        subTitle="Envie questionários e formulários."
        link=''
      />
      <PortalComunicacao
        image={<TutorialIcon theme={theme.primary}/>}
        title='Tutorial'
        subTitle="Tutoriais sobre o portal."
        link=''
      />
    </Grid>
  )
}
